module.exports = __webpack_public_path__ + "static/media/involvementIcon.cb6b7730.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/involvementIcon.png
// module id = 482
// module chunks = 0